<template>
    <div>
      <div class="head-box">
       	<img v-if="searchType === 'homePage'" class="head-left" src="../../../assets/images/logo.png" alt="" />
       	<img v-else class="go-back" @click.stop="goBack" src="../../../assets/images/icon/icon-arrow.png" alt="" />
       	<van-search :disabled="isDisabled" class="head-right" v-model="value" clear-trigger="always" @clear.stop="clearSearch" @search="searchChange" @focus="focusSearch" shape="round" :background="searchType === 'homePage' ? 'rgb(144,185,252)' : ''" placeholder="商品型号/商品名称" />
        <span v-if="!isDisabled" class="search-change" @click="searchChange">搜索</span>
        <img v-if="searchType === 'homePage'" @click.stop="closeHome" class="head-close" src="../../../assets/images/close.png" alt="" />
      </div>
    </div>
</template>

<script>
  export default {
    name: 'search-head',
    props: {
      searchType: {
        type: String,
        default: ''
      },
      searchValue: {
        type: String,
        default: ''
      },
      isDisabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
        return {
          value: '',
        }
    },
    watch: {
      searchValue: {
        handler(newValue) {
          this.value = newValue;
        },
        immediate: true,
        deep: false
      }
      
    },
    components:{},
    created(){
      this.value = this.searchValue;
    },
    methods:{
      closeHome() {
        document.addEventListener("deviceready", function() {
          if (window.cordova) {
            window.cordova.exec(function () {
              console.log('退出');
            }, function () {
            }, "MideaCommon", "exitPreWidgetWeb", []);
          }
        });
      },
      goBack() {
        window.history.back();
      },
      searchChange() {
        this.$emit('searchValue', this.value);
      },
      clearSearch() {
        sessionStorage.setItem("searchValue", '');
      },
      focusSearch() {
        this.$emit('focusSearch');
      }
    }
  }
</script>


<style scoped>
  .head-box {
    display: flex;
    width: 100%;
    height: 100px;
  }
  .head-left {
    width: 80px;
    height: 56px;
    margin-left: 50px;
    margin-top: 29px;
  }
  .head-close {
    position: absolute;
    right: 20px;
    top: 26px;
    width: 60px;
    height: 60px;
  }
  .head-right {
    margin-left: 20px;
    margin-top: 15px;
  }
  .go-back {
    width: 50px;
    height: 50px;
    margin-left: 50px;
    margin-top: 30px;
    margin-right: 30px;
    transform: rotate(180deg);
  }
  .head-box >>> .van-search__content--round {
    height: 60px;
  }
  .head-box >>> .van-field__control {
    font-size: 30px;
    margin-top: 10px;
  }
  .head-box >>> .van-icon-search {
    font-size: 30px;
    top: 15px;
  }
  .head-box >>> .van-icon-clear {
    font-size: 40px !important;
    margin-right: 10px;
  }
  .search-change {
    display: inline-block;
    width: 100px;
    height: 100px;
    font-size: 30px;
    line-height: 120px;
    text-align: center
  }
</style>



// WEBPACK FOOTER //
// src/pages/retail/components/searchHead.vue